import { PdpDeliveryType } from '../type/common.type';

/** 기본 드롭다운 인덱스 (-1은 선택되지 않은 상태를 의미) */
export const DEFAULT_DROPDOWN_INDEX = -1;

/** 첫 번째 드롭다운의 인덱스 (0부터 시작) */
export const DROPDOWN_FIRST_INDEX = 0;

/** 메인 옵션 그룹의 인덱스 (1 이상인 경우 BOGO 상품) */
export const MAIN_DROPDOWN_GROUP_INDEX = 0;

/** 기본 최대 주문 수량 (999개까지 주문 가능) */
export const DEFAULT_MAX_COUNT = 999;

/** 기본 최소 주문 수량 (최소 1개는 주문해야 함) */
export const DEFAULT_MIN_COUNT = 1;

/** 최소 주문 수량 타입 정의 */
export const MINIMUM_ORDER_QUANTITY_TYPE = {
  /** 상품 단위로 최소 주문 수량 적용 */
  PRODUCT: 'PRODUCT',
  /** 아이템 단위로 최소 주문 수량 적용 */
  ITEM: 'ITEM',
};

/** 옵션 타입 정의 */
export const OPTION_TYPE = {
  /** 기본 옵션 (필수 선택 옵션) */
  BASIC: 'BASIC',
  /** 추가 옵션 (선택적 옵션) */
  ADDITIONAL: 'ADDITIONAL',
};

/** 구매 지연 시간 (300ms, 중복 클릭 방지를 위한 디바운싱 시간) */
export const PURCHASE_DELAY_TIME = 300;

/** 빠른 배송 타입 목록 (지그진, 벤더 플렉스 배송) */
export const FAST_DELIVERY_TYPES = [PdpDeliveryType.ZIGZIN, PdpDeliveryType.VENDOR_FLEX];
